var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpieleranzahl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.77 61.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #ec6746;\n        stroke-miterlimit: 10;\n        stroke-width: 3.39px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.37,24.31c2.88,2.49,4.71,6.17,4.71,10.27v23.08c0,.98-.8,1.78-1.78,1.78H3.47c-.98,0-1.78-.8-1.78-1.78v-23.08c0-4.07,1.79-7.72,4.63-10.2M28.81,15.88c0,7.83-5.59,14.18-12.49,14.18S3.83,23.71,3.83,15.88,9.43,1.7,16.32,1.7s12.49,6.35,12.49,14.18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpieleranzahl);
export default __webpack_public_path__ + "static/media/Spieleranzahl.e8b05021b2c5b9d3ed926dfccc375033.svg";
export { ForwardRef as ReactComponent };